import {
  forEach,
  map,
  mapValues,
  pickBy
} from 'lodash'
import { parse } from 'date-fns'

/**
 * Generates the filter criteria for a search. This is called internally on
 * filter submit to send the caller the state of the filter key / value pairs
 * Client components may want to call this directly if the component is
 * maintaining its own additional search filters. A common case is a component
 * that provides view states as well as search filters
 *
 * @param values is an object or map with keys and values
 */
export const generateQueryFilters = (
  filters: any,
  values: any
) => {
  const filterAttribute = (
    filtersProp: any,
    attribute: any
  ) => {
    // Using an object to emulate a hashmap.  While normally a datasmall set,
    // there are three 0(n^2) operations below that I wanted to optimize
    const filtersWithAttribute = {} as Record<string, any>
    forEach(filtersProp, row => {
      forEach(row, value => {
        if (value[attribute]) {
          filtersWithAttribute[value.name] = true
        }
      })
    })
    return filtersWithAttribute
  }

  const LIKE_CRITERIA = '%'

  const likeFields: Record<string, any> = filterAttribute(filters, 'like')
  const dateFields: Record<string, any> = filterAttribute(filters, 'date')
  const practitionerSearchFields = filterAttribute(filters, 'practitionerSelect')

  const onlyValues = pickBy(values, (value: string): Record<string, string[]> | boolean => {
    if (Array.isArray(value)) {
      return value.length > 0
    }
    return !!value
  })

  // if string has space, wrap string in parens, only if parens are not present
  const wrapParen = (txt: string): string => {
    if (txt.indexOf(' ') > 0 && !(txt[0] === '(' && txt[txt.length - 1] === ')')) {
      return `(${txt})`
    }
    return txt

  }

  if ('appointmentType' in onlyValues) {
    onlyValues.appointmentType = map(onlyValues.appointmentType as string[], wrapParen)
  }
  if ('specialty' in onlyValues) {
    onlyValues.specialty = map(onlyValues.specialty as string[], wrapParen)
  }

  const withWildcard = mapValues(
    onlyValues,
    (
      value, key
    ) => (likeFields[key]
      ? `${value}${LIKE_CRITERIA}`
      : value
    )
  )
  const withDate = mapValues(
    withWildcard,
    (
      value: string | number | Date, key: string
    ) => (dateFields[key]
      ? parse(value)
      : value
    )
  )
  const withPractitionerSearch = mapValues(
    withDate, 
    (
      value, key
    ) => (practitionerSearchFields[key] 
      ? value 
      : value
    )
  )

  return withPractitionerSearch
}

export default generateQueryFilters
